import React from "react";
import styles from "./CTA.module.css";

interface CTAProps {
  title: string;
  description: string;
  buttonText: string;
}

const CTA: React.FC<CTAProps> = ({ title, description, buttonText }) => {
  const handleCTAClick = () => {
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="contact" className={styles.ctaSection}>
      <div className="container">
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        <button onClick={handleCTAClick} className={styles.ctaButton}>
          {buttonText}
        </button>
      </div>
    </section>
  );
};

export default CTA;
